import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import partial from 'transmute/partial';
import memoize from 'transmute/memoize';
import { Big } from 'foundations-components/transitional/components/Big';
import { Link } from 'foundations-components/transitional/components/Link';
import { Image } from 'foundations-components/transitional/components/Image';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import PageType from 'customer-data-objects-ui-components/propTypes/PageType';
import * as PageTypes from 'customer-data-objects/view/PageTypes';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { View } from 'foundations-components/transitional/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getColumnType = objectType => {
  const message = isValidI18nKey(`genericTypes.${objectType}`) ? `genericTypes.${objectType}` : 'genericTypes.items';
  return unescapedText(message);
};
export class EmptyStateMessage extends PureComponent {
  constructor(props) {
    super(props);
    // In new code, please use ES6 spread args rather than partials
    // for easier debugging and readability:
    // (...args) => myFunction('partiallyAppliedParam', ...args)
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Function' is not assignable to p... Remove this comment to see the full error message
    this.handleTrackLinkClick = (linkHref, linkText) => {
      CrmLogger.logCRMOnboarding(this.props.objectType, {
        action: 'clicked empty state link',
        link: linkHref,
        text: linkText
      });
    };
    this.partial = memoize(partial);
    this.handleTrackLinkClick = this.handleTrackLinkClick.bind(this);
  }
  renderCTALink() {
    const {
      ctaText,
      ctaLink
    } = this.props;
    if (!ctaText || !ctaLink) {
      return null;
    }
    return /*#__PURE__*/_jsx(Button, {
      use: "tertiary-light",
      href: ctaLink,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: ctaText
      })
    });
  }
  renderPrimaryContent() {
    const {
      children,
      isKnowledgeBaseButton,
      linkHref,
      linkText,
      objectType,
      subText,
      translatedSubtext,
      CustomCTAComponent,
      renderSubText
    } = this.props;
    const isSubtextVisible = renderSubText || subText || translatedSubtext;
    const defaultTranslatedSubtext = renderSubText ? renderSubText() : subText && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: subText,
      options: {
        columnType: getColumnType(objectType)
      }
    });
    return /*#__PURE__*/_jsxs("span", {
      children: [isSubtextVisible && /*#__PURE__*/_jsx(Big, {
        "data-test-id": "empty-state-subtext",
        tagName: "p",
        use: "help",
        children: translatedSubtext || defaultTranslatedSubtext
      }), isSubtextVisible && !isKnowledgeBaseButton && linkText && linkHref && /*#__PURE__*/_jsx("p", {
        "data-test-id": "empty-state-link",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: linkText,
          options: {
            href: linkHref,
            onClick: this.partial(this.handleTrackLinkClick, linkHref, linkText)
          },
          elements: {
            Link
          }
        })
      }), isSubtextVisible && isKnowledgeBaseButton && /*#__PURE__*/_jsx("p", {
        "data-test-id": "empty-state-kb-button",
        children: /*#__PURE__*/_jsx(KnowledgeBaseButton, {
          url: linkHref,
          useZorse: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: linkText || ''
          })
        })
      }), this.renderCTALink(), CustomCTAComponent && /*#__PURE__*/_jsx(CustomCTAComponent, {}), children]
    });
  }
  render() {
    const {
      illustration,
      illustrationWidth = 200,
      imageUrl,
      imageWidth = 200,
      objectType,
      pageType,
      reversed,
      secondaryContentWidth = 200,
      titleText
    } = this.props;
    const isCardWrapperNeeded = pageType !== 'index';
    const secondaryContent = imageUrl ? /*#__PURE__*/_jsx(Image, {
      src: imageUrl,
      width: imageWidth
    }) : /*#__PURE__*/_jsx(Illustration, {
      name: illustration || '',
      width: illustrationWidth
    });
    const emptyState = /*#__PURE__*/_jsx(EmptyState, {
      flush: true,
      primaryContent: this.renderPrimaryContent(),
      reverseOrder: reversed,
      secondaryContent: secondaryContent,
      secondaryContentWidth: secondaryContentWidth,
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: titleText,
        options: {
          columnType: getColumnType(objectType)
        }
      })
    });
    return /*#__PURE__*/_jsx("div", {
      "data-selenium-test": "EmptyStateMessage",
      children: isCardWrapperNeeded ? /*#__PURE__*/_jsx(CardWrapper, {
        children: /*#__PURE__*/_jsx(CardSection, {
          children: emptyState
        })
      }) : /*#__PURE__*/_jsx(View, {
        marginInline: "auto",
        marginBlock: "600",
        as: "div",
        children: emptyState
      })
    });
  }
}
EmptyStateMessage.propTypes = {
  children: PropTypes.node,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  ctaLinkQueryBlackList: PropTypes.array,
  illustration: PropTypes.string,
  illustrationWidth: PropTypes.number,
  isKnowledgeBaseButton: PropTypes.bool,
  imageUrl: PropTypes.string,
  imageWidth: PropTypes.number,
  linkHref: PropTypes.string,
  linkText: PropTypes.string,
  objectType: AnyCrmObjectTypePropType.isRequired,
  pageType: PageType.isRequired,
  params: PropTypes.object,
  query: PropTypes.string,
  queryParams: PropTypes.object,
  reversed: PropTypes.bool,
  secondaryContentWidth: PropTypes.number,
  subText: PropTypes.string,
  renderSubText: PropTypes.func,
  titleText: PropTypes.string.isRequired,
  translatedSubtext: PropTypes.node,
  CustomCTAComponent: PropTypes.func
};
EmptyStateMessage.defaultProps = {
  reversed: false,
  pageType: PageTypes.INDEX
};
export default EmptyStateMessage;